import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type DialogOverlayProps = DialogPrimitive.Backdrop.Props;

const DialogOverlay = ({ className, ...props }: DialogOverlayProps) => {
  return (
    <DialogPrimitive.Backdrop
      data-slot="dialog-overlay"
      className={cn(
        'fixed inset-0 isolate z-1100 bg-black/50 duration-100 supports-backdrop-filter:backdrop-blur-xs',
        'data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0',
        className,
      )}
      {...props}
    />
  );
};

export default DialogOverlay;
